const getChildProjects = state => state?.childProjects ?? [];

export default {
  getChildProjects,
};
